/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Sat Mar 16 2024
 **/

// import { useAtomValue } from "jotai";
// import { JotaiStore } from "@/frameworks/libraries/commons";
// import usePhoneCallActions from "./usePhoneCallActions";
// import PhoneCallAtoms from "./PhoneCallAtoms";
import { useBootAPI, useCallAPI, usePopupAPI, useSendStatus, useStateAPI, useUserAPI, useStreamAPI } from "./private";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOGTAG = "#usePhoneCall#";

export default function usePhoneCall() {
	// const callList = useAtomValue(PhoneCallAtoms.CallList, { store: JotaiStore });
	// const callAction = usePhoneCallActions();
	const boothManager = useBootAPI();
	const callManager = useCallAPI();
	const popupManager = usePopupAPI();
	const userManager = useUserAPI();
	const stateManager = useStateAPI();
	const streamManager = useStreamAPI();
	const send_status = useSendStatus();
	const allCallEnding = async () => {
		// await Promise.all(
		// 	Object.entries(callList).map(([callID]) => {
		// 		// return dial(callID).end();
		// 	})
		// );
	};

	return {
		...boothManager,
		...callManager,
		...userManager,
		send_status,
		state: stateManager,
		popup: popupManager,
		stream: streamManager,

		// old
		allCallEnding
	};
}
